/**
 * F-0704, EXA-8 (D2): what Join hands to the page the person lands on, in the navigation's own
 * state, so the confirmation survives the navigation away from Settings. The role is a key, not a
 * word: the landing page says it in the reader's language.
 */
export interface IExampleJoinedState {
  name: string;
  role: string;
  /**
   * F-0739: `public` when a Public work area let the person in. Then the notice does not say that the
   * whole organisation can join, which is only true of an example's self-registration.
   */
  via?: 'public';
}

export const EXAMPLE_JOINED_STATE_KEY = 'exampleJoined';

export function exampleJoinedState(
  joined: IExampleJoinedState,
): Record<string, IExampleJoinedState> {
  return { [EXAMPLE_JOINED_STATE_KEY]: joined };
}

/** The joined notice a navigation carries, or null for any other state. */
export function readExampleJoined(state: unknown): IExampleJoinedState | null {
  if (typeof state !== 'object' || state === null) return null;
  const joined = (state as Record<string, unknown>)[EXAMPLE_JOINED_STATE_KEY];
  if (typeof joined !== 'object' || joined === null) return null;
  const { name, role, via } = joined as Record<string, unknown>;
  if (typeof name !== 'string' || typeof role !== 'string') return null;
  return via === 'public' ? { name, role, via } : { name, role };
}
